<template>
  <div class="baidu-modify-wrapper">
    <FixedHeader v-model="currentTaskId" @change="onTaskTabChange" @remove="onTaskTabRemove" :before-change="doCurrentFormValidate">
      <FixedItem v-for="task in taskStates" :key="task.id" :data="task">{{ task.id }}</FixedItem>
    </FixedHeader>

    <div class="plans-modify ghost-button-styles" v-if="formData.taskId">
      <!-- 基础信息 -->
      <Moduler title="基础信息" name="basic">
        <BaisicInfos ref="baidu-basic" :class="innerPlanModifyForbid"></BaisicInfos>
      </Moduler>

      <!-- 流量及投放方式 -->
      <Moduler title="流量及投放方式" name="basic">
        <StreamType ref="baidu-stream" :class="outterPlanModifyForbid"></StreamType>
      </Moduler>

      <!-- 用户定向 -->
      <Moduler title="用户定向" name="basic">
        <UserTargetings ref="baidu-targeting" :class="outterPlanModifyForbid"></UserTargetings>
      </Moduler>

      <!-- 出价设置 -->
      <Moduler title="出价设置" name="basic">
        <Budget ref="baidu-budget" :class="outterPlanModifyForbid"></Budget>
      </Moduler>

      <!-- 创意-->
      <Moduler title="创意" name="basic">
        <BaiduCreatives ref="baidu-creative"></BaiduCreatives>
      </Moduler>
    </div>

    <div class="empty-loading" v-else v-loading="pageLoading"></div>

    <div class="ad-submit">
      <Button @click="doCannel">取消</Button>
      <Button type="primary" :loading="submitLoading" @click="submit"> 确认提交 </Button>
    </div>
  </div>
</template>
<script>
import BaisicInfos from './basic.vue'
import UserTargetings from './targeting.vue'
import Budget from './budget-bid.vue'
import BaiduCreatives from './creatives.vue'
import StreamType from './stream-type.vue'
import Moduler from '@/components/moduler'
import { FixedHeader, FixedItem } from '@/components/fixed-header/index.js'
import editCommonMethdos from '../common/edit.js'

import { getSession } from '@/common/js/api'
import { findPlanTaskById } from '@/api/toutiao.local.model'
import { addBaiduBatchTask, updateBaiDuBatchTask } from '@/api/baidu.local.model'

const taskIds = getSession('taskIds') || []

// 百度测试账号 原生-CHYF119-B19KA02712
export default {
  components: {
    Moduler,
    FixedHeader,
    FixedItem,
    BaisicInfos,
    StreamType,
    UserTargetings,
    Budget,
    // AdPosition,
    BaiduCreatives
  },
  computed: {
    // 当外部计划创建成功时，且是在批量失败修改时，禁止对计划参数修改
    outterPlanModifyForbid() {
      const planSucc = this.formData.task_progress >= 5
      return planSucc && this.editState ? 'disable-plan-form' : ''
    },
    innerPlanModifyForbid() {
      const planSucc = this.formData.task_progress >= 4
      return planSucc && this.editState ? 'disable-plan-form' : ''
    },
    editState() {
      return this.$route.path.includes('/edit/')
    },
    taskInfo() {
      return this.$store.state.Baidu.taskInfo
    },
    taskList: {
      get() {
        return this.$store.state.Baidu.taskList
      },
      set(list) {
        this.$store.commit('Baidu/UPDATE_TASK_LIST', list)
      }
    },
    formData: {
      get() {
        return this.$store.getters['Baidu/currTaskParams']
      },
      set(form) {
        this.$store.commit('Baidu/UPDATE_CURR_TASK', form)
      }
    },
    duplicationState() {
      return this.$route.path.includes('/duplicate/')
    },
    submitList() {
      return this.$store.getters['Baidu/submitParams']
    },
    currentTaskId: {
      get() {
        return this.taskInfo.currTaskId
      },
      set(currTaskId) {
        this.$store.commit('Baidu/SET_CURR_TASK_INFO', { ...this.taskInfo, currTaskId })
      }
    },
    taskStates() {
      return this.taskList.map((task) => task.taskStates)
    }
  },
  data() {
    return {
      formPrefix: 'baidu',
      pageLoading: false,
      submitLoading: false
    }
  },
  methods: {
    /**
     * @description: onTaskTabRemove, onTaskTabChange, taskFormValidator, doCurrentFormValidate, doCannel
     * @return {*}
     */
    ...editCommonMethdos,

    /**
     * @description: 提交全部任务修改
     */
    submit() {
      const allFilled = this.taskStates.every((s) => s.filled)
      if (!allFilled) {
        return this.$Message.error(' 请切换任务编号，首次加载数据成功方可复制')
      }

      console.log('this.submitList output: ', this.submitList)

      this.submitLoading = true

      this.doCurrentFormValidate()
        .then(() => {
          const params = { operation: this.duplicationState ? this.formData.operation : 'enable', planlist: this.submitList }
          console.log('params output: ', params)
          ;(this.duplicationState ? addBaiduBatchTask(params) : updateBaiDuBatchTask(params)).then((data) => {
            if (data) {
              this.$Message.success('提交成功， 2秒后自动关闭页面')

              setTimeout(() => {
                window.close()
              }, 2000)
            }

            this.submitLoading = false
          })
        })
        .catch((e) => {
          this.submitLoading = false
          console.log('doCurrentFormValidate error output: ', e)
        })
    },
    setOperation() {
      console.log('this.formData.operation output: ', this.formData.operation)
      this.formData = {
        ...this.formData,
        operation: this.editState ? this.formData.operation : 'enable'
      }
    },
    getData() {
      this.pageLoading = true
      Promise.all([findPlanTaskById({ taskIds })]).then((data) => {
        let [tasks] = data

        if (this.duplicationState) {
          tasks = tasks.map((task) => {
            const inner_plan_params = task.inner_plan_params
            inner_plan_params.plan_name += '_复制'
            return { ...task, inner_plan_params }
          })
        }

        this.pageLoading = false

        this.$store.commit('Baidu/SET_MODIFY_PARAMS', tasks || [])
        this.setOperation()
      })
    }
  },
  created() {
    this.getData()
    // 默认第一个任务
    this.currentTaskId = taskIds[0] || 0
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.baidu-modify-wrapper {
  height: calc(100vh - 64px);
  overflow: auto;
}
.plans-modify {
  padding: 15px;
}
.empty-loading {
  height: 100vh;
}
.ad-submit {
  position: sticky;
  bottom: 0;
  z-index: 999;
  padding: 16px 24px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="scss">
.disable-plan-form {
  position: relative;
  z-index: 1;
  .ivu-input {
    z-index: 1;
  }

  &:before {
    width: 100%;
    height: calc(100% + 40px);
    content: ' ';
    position: absolute;
    margin-top: -20px;
    margin-bottom: -20px;
    background-color: rgba(88, 88, 88, 0.04);
    cursor: not-allowed;
    z-index: 2;
  }
}
</style>
